// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"SJ-z","carouselContainer":"TJ-z"};